import { render, staticRenderFns } from "./addAttributeVal.vue?vue&type=template&id=2592f0f0"
import script from "./addAttributeVal.vue?vue&type=script&lang=js"
export * from "./addAttributeVal.vue?vue&type=script&lang=js"
import style0 from "./addAttributeVal.vue?vue&type=style&index=0&id=2592f0f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports